import { ViewDensity } from "@common/types/views/views";
import type { DataGridDensity } from "../types";

/**
 * A saved view's density as row height, matching ViewTable's: low density
 * (`sm`) has the tallest rows, high (`lg`) the shortest.
 */
export const DENSITY_BY_VIEW_DENSITY: Record<ViewDensity, DataGridDensity> = {
    [ViewDensity.SM]: "relaxed",
    [ViewDensity.MD]: "default",
    [ViewDensity.LG]: "compact",
};

export const VIEW_DENSITY_BY_DENSITY: Record<DataGridDensity, ViewDensity> = {
    relaxed: ViewDensity.SM,
    default: ViewDensity.MD,
    compact: ViewDensity.LG,
};
